import { SummaryApi } from 'api/SummaryApi';
import dayjs from 'dayjs';
import { ProjectSummary } from 'model/ProjectSummary';

export class ProjectSummaryMapper {
  deserializeCombine(entry: SummaryApi.ProjectSummary): ProjectSummary {
    return {
      id: Number(entry.id),
      score: entry.score,
      date: dayjs(entry.date),
      benchmark: entry.benchmark,
      status: entry.type,
    };
  }
}
